module.exports = __webpack_public_path__ + "images/application/i-delete-470c9a80.svg";